import React, { Component } from 'react';
import {createSelector} from "reselect";
import {connect} from "react-redux";
import { Main } from '../../layout';
import { BookTutor, LoginDialog, RatingListings } from '../Common';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import Skeleton from '@material-ui/lab/Skeleton';
import Rating from '@material-ui/lab/Rating';
import { IconButton, Tooltip } from '@material-ui/core';
import { confirmAlert } from 'react-confirm-alert';
import moment from 'moment-timezone';
import { Role } from '../../../helpers';

class TutorSearchView extends Component {

    constructor(props) {

        super(props);
        this.state = {
            id: null,
            item: null,
            loading: false,
            open: false,
            openBooking: false,
        };
    }

    componentDidMount() {
        const { match } = this.props;
        const item_id = match.params.id;
        this.setState({ id: item_id ? item_id : null });
        this.viewTutor(item_id);
    }

    componentDidUpdate(prevProps) {
        const { match } = this.props;
        if (this.props.match.params.id !== prevProps.match.params.id) {
            const id = match.params.id;
            this.setState({ id: id ? id : null });
            if (id !== prevProps.match.params.id) {
                this.viewTutor(id);
            }
        }
    }

    viewTutor = (id) => {
        const { dispatch } = this.props;
        this.setState({loading: true});
        itemService.profile("GET", null, {item_id: id}).then(data => {
            if(data.code) {
                let item = data.user;
                //console.log('data', item);
                this.setState({loading: false, item});
            }
        })
        .catch(exception => {
            gs.showErrors(exception, dispatch, alertSelectors);
            this.setState({loading: false});
        });
    }

    markAsFavorite = (item) => {
        if(!gs.identity) {
            this.setState({open: true});
            return false;
        }
        const { dispatch, authentication } = this.props;
        const { user } = authentication.authentication;
        const params = {
            "userFavorite": {
                user_id: user.id,
                favorite_id: item.id,
                moduleId: "UserProfile"
            }
        };

        let method = (item.is_favorite) ? "DELETE" : "POST";
        let param = (item.is_favorite) ? { item_id: item.is_favorite } : null;
        let action = (item.is_favorite) ? "remove" : "add";

        //console.log('item', item, params, method, param, action);
        //return false;

        confirmAlert({
            title: `Please confirm to ${action}`,
            message: `Are you sure to ${action} this favorite list`,
            buttons: [
                {
                    label: 'No',
                    onClick: () => dispatch(alertSelectors.success("You have not accepted the request."))
                },
                {
                    label: 'Yes',
                    onClick: () =>
                        itemService.favorite(method, params, param)
                            .then(response => {
                                if (method === "POST") dispatch(alertSelectors.success("You have successfully selected a favorite."));
                                if (method === "DELETE") dispatch(alertSelectors.success("You have successfully removed a favorite."));
                                item.is_favorite = (method === "POST") ? response.model.id : false;
                                this.setState({ favorite: item });
                            })
                            .catch(exception => {
                                gs.showErrors(dispatch, exception, alertSelectors);
                            })
                }
            ]
        });
    }

    loadSlots = (user_id = null, item_id = null, start_time = null) => {
        const { dispatch } = this.props;
        this.setState({bookingDialogDisplay: false});
        itemService.availability("GET", null, {user_id: user_id, item_id: item_id, start_time: start_time}).then(data => {
            let isAvailable = data.isAvailable;
            let slots = data.slots ? data.slots : [];
            this.setState({...this.state, isAvailable, slotList: slots, bookingDialogDisplay: true });
        })
        .catch(exception => {
            gs.showErrors(dispatch, exception, alertSelectors);
            this.setState({bookingDialogDisplay: false});
        });
    }

    bookTutor = () => {
        const { item } = this.state;
        const subjects = item && item.userCatalogs;
        if(subjects && subjects.length === 0) {
            alert('Subject not found');
            return false;
        }
        if(gs.identity) {
            this.setState({openBooking: true});
            return false;
        } else {
            this.setState({open: true});
            return false;
        }
    }

    bookingDialogClose = (event, e = null) => {
        this.setState({openBooking: false});
    }

    render() {
        const { open, openBooking, item } = this.state;
        const { match, authentication } = this.props;
        const educations = item && item.userEducations;
        const experiences = item && item.userExperiences;
        const awards = item && item.userAwards;
        const subjects = item && item.userProfile && item.userProfile.userCatalogs;
        const user = authentication && authentication.authentication && authentication.authentication.user;
        //console.log('itemitem', item && item.userProfile)

        return (<Main>
            <LoginDialog open={open} handleClose={() => this.setState({open: false})} link={`/tutor/view/${match.params.id}`} />
            {item && item && <BookTutor open={openBooking} handleClose={this.bookingDialogClose} item={item} />}
            <section className="view-page my-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="post-box view-detail">
                                <div className="row">
                                    <div className="col-md-8 col-12 mb-3">
                                        <div className="media">
                                            <div className="image">
                                                <img className="mr-4" src={(item && item.avatar) ? item.avatar : '/images/dummy-profile.png'} alt="pic"/>
                                            </div>
                                            <div className="media-body">
                                                <div className="d-flex flex-wrap mb-2">
                                                    <h3>{item && item.name}</h3> 
                                                    <div className="rating ml-lg-5 ml-sm-3">
                                                        <span className="star">
                                                            {(item && item) && <Rating name="size-medium" size="small" value={(item && item.rating_avg) ? parseFloat(item && item.rating_avg) : 0} readOnly />}
                                                        </span>
                                                        <span className="rate"> ({item && item.rating_avg}) {item && item.count_rating} Ratings</span>
                                                    </div>
                                                </div> 
                                                <h6>{item && item.about}</h6> 
                                                <div className="location">
                                                    <i className="fas fa-map-marker-alt"></i> United State
                                                </div> 
                                                <div className="justify-content-between d-flex flex-wrap">
                                                    <div className="sub">
                                                        <h5 className="text-primary">Subject</h5>
                                                        {subjects && subjects.map(sub => 
                                                            <span key={`sub-${sub.id}`} className="badge badge-light py-2 px-3 mr-2 mb-3">{sub.title} ${sub.price}</span>
                                                        )}
                                                        {(subjects && subjects.length === 0) && 'Subject not found'}
                                                    </div>
                                                    <div className="book d-flex align-items-start">
                                                        {(subjects && subjects) && <>
                                                            {((item && item.role !== Role.Tutor) || (user === null)) ? <>
                                                                <button className="btn btn-secondary text-white" onClick={this.bookTutor} >Book Tutor</button> 
                                                            </>: 
                                                            <button className="btn btn-secondary text-white" onClick={this.bookTutor} >Book Tutor</button>}
                                                        </>}
                                                        <Tooltip title="The payment will be processed after the session." placement="top-start">
                                                            <i className="fas fa-info-circle ml-2"></i>
                                                        </Tooltip>
                                                       {/* <i className="fas fa-info-circle ml-2" data-toggle="tooltip" data-placement="top" title="The payment will be processed after the session."></i> */}
                                                    </div>
                                                </div>   
                                            </div> 
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-12">
                                       <div className="wishlist text-right mb-3">
                                            {((item && item.role !== Role.Tutor) || (user === null)) ?
                                            <IconButton className="favorite p-0" aria-label="Favorite" onClick={() => this.markAsFavorite(item && item.userProfile)}>
                                                <i className={`fas fa-heart ${(item && item.userProfile.is_favorite) ? 'text-primary' : ''}`}></i>
                                            </IconButton> :
                                            <IconButton className="favorite p-0" aria-label="Favorite" onClick={() => this.markAsFavorite(item && item)}>
                                                <i className={`fas fa-heart ${(item && item.userProfile.is_favorite) ? 'text-primary' : ''}`}></i>
                                            </IconButton>}
                                        </div>
                                        {/* <div className="session text-right mb-3">
                                             60 min ($15.00 / Session)
                                        </div> */}
                                        <div className="text-right mb-3">
                                            {((item && item.role !== Role.Tutor) || (user === null)) && <button className="btn msg-btn" >Message</button>}
                                        </div>
                                        <div className="calender text-right">
                                            <button className="btn btn-info">
                                                <i className="far fa-calendar-alt"></i> {moment(new Date()).format('MM/DD/YYYY')} 
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="post-box p-0">
                                <div className="detail">
                                    <div className="heading">
                                        Education
                                    </div>
                                    <div className="category">
                                        {(!item) ? <>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </> : <>
                                            {educations && educations.map(education => 
                                                <div className="row" key={`edu-${education.id}`}>
                                                    <div className="col-md-5 col-12">
                                                        <p>{education.title}</p>
                                                    </div>
                                                    <div className="col-md-4 col-12">
                                                        <p>{education.institute}</p>
                                                    </div>
                                                    <div className="col-md-3 col-12">
                                                        <p>{moment(education.from * 1000).format('MM/YYYY')} – {education.is_present === 1 ? 'Present' : moment(education.to * 1000).format('MM/YYYY')}</p>
                                                    </div>
                                                </div>
                                            )}
                                            {(educations && educations.length === 0) &&
                                                <div className="w-100">Education not found</div>
                                            }
                                        </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="post-box p-0">
                                <div className="detail">
                                    <div className="heading">
                                        Experience
                                    </div>
                                    <div className="category">
                                    {(!item) ? <>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </> : <>
                                            {experiences && experiences.map(experience => 
                                                <div className="w-100" key={`expe-${experience.id}`}>
                                                    <div className="d-flex flex-wrap justify-content-between">
                                                        <h4>{experience.title}</h4>
                                                        <h4>{moment(experience.from * 1000).format('MM/YYYY')} – {experience.is_present === 1 ? 'Present' : moment(experience.to * 1000).format('MM/YYYY')}</h4>   
                                                    </div>
                                                    <p className="text">
                                                        {experience.description}
                                                    </p>
                                                </div>
                                            )}
                                            {(experiences && experiences.length === 0) &&
                                                <div className="w-100">Experience not found</div>
                                            }
                                        </>}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="post-box p-0">
                                <div className="detail">
                                    <div className="heading">
                                    Award / Certification
                                    </div>
                                    <div className="category">
                                        {(!item) ? <>
                                            <Skeleton variant="text" />
                                            <Skeleton variant="text" />
                                        </> : <>
                                            {awards && awards.map(award => 
                                                <div className="w-100" key={`awar-${award.id}`}>
                                                    <div className="d-flex flex-wrap justify-content-between">
                                                        <h4>{award.title}</h4>
                                                        {/* <h4>{moment(award.from * 1000).format('MM/YYYY')} – {award.is_present === 1 ? 'Present' : moment(award.to * 1000).format('MM/YYYY')}</h4>    */}
                                                    </div>
                                                    <p className="text">
                                                        {award.description}
                                                    </p>
                                                </div>
                                            )}
                                            {(awards && awards.length === 0) &&
                                                <div className="w-100">Award not found</div>
                                            }
                                        </>}
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="post-box p-0">
                                <div className="detail">
                                    <div className="heading">
                                    About the Tutor
                                    </div>
                                    <div className="category">
                                        <p className="text">
                                        {item && item.about}
                                        </p>  
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="post-box p-0">
                                <RatingListings productData={item && item} match={this.props.match} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Main>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    processSelector,
    authenticationSelector,
    (process, authentication) => ({
        process, authentication
    })
);

export default connect(mapStateToProps)(TutorSearchView);